import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { Paragraph } from '../../typography'

const ErrorMsg = styled(Paragraph)`
  font-weight: ${(props) => props.theme.fontWeights.bold};
  color: ${(props) => props.theme.colors.error};
  text-align: ${(props) => props.textAlign};
  margin-top: ${(props) => props.theme.spacing[props.mt]}px;
`

export const ErrorMessage = ({ mt = 'none', textAlign = 'center', error, children, ...props }) => (
  <ErrorMsg textAlign={textAlign} mt={mt}>
    {error?.message ||
      error ||
      (children !== undefined ? children : <FormattedMessage {...props} />)}
  </ErrorMsg>
)
